<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Вход</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form @submit.prevent="loginto">
                <v-text-field
                 v-model.trim="logindata.Email"
                 label="Email" name="Email" 
                 prepend-icon="mdi-email" 
                 type="text" 
                 :hint="{invalid: ($v.email.$dirty && !$v.email.required) || ($v.email.$dirty && !$v.email.email)}"/>
                <v-text-field v-model.trim="logindata.Password" type="password" label="Пароль" prepend-icon="mdi-lock"/>
              </v-form>
            </v-card-text>
            <v-card-actions>
                <v-btn color="info" align-center justify-center to="/register">Регистрация</v-btn>
                <v-spacer />
                <v-btn color="success" align-center justify-center type="submit" @click.prevent="loginto">Вход</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import LoginService from '../api-services/login.services'
import {email, required} from 'vuelidate/lib/validators'


export default {
  data(){
    return{
      logindata: {}
    };
  },
  components: LoginService,
  validations:{
    email:{email, required},
    password:{required}
  },
  methods: {
    async loginto(){
      if(this.$v.$invalid){
        this.$v.touch()
        return 
      }
      try{
        LoginService.login(this.logindata)
        this.$store.dispatch()
        this.$router.push("/")
      }
      catch(e){}
       
    }
  }
}
</script>